function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFoldedCardLandscape = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.77 43.09",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.08 23.19c-2.56 0-4.63-2.09-4.63-4.65s2.09-4.63 4.65-4.63 4.63 2.09 4.63 4.65-2.09 4.63-4.65 4.63Zm.02-6.96c-1.28 0-2.32 1.03-2.33 2.31s1.03 2.32 2.31 2.33 2.32-1.03 2.33-2.31-1.03-2.32-2.31-2.33ZM31.2 33.46c-.3 0-.59-.11-.82-.34l-8.45-8.49-6.16 6.12c-.45.45-1.19.45-1.64 0-.45-.45-.45-1.19 0-1.64l6.98-6.94c.45-.45 1.19-.45 1.64 0l9.26 9.32c.45.45.45 1.19 0 1.64-.23.23-.52.34-.82.34Z",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.49 33.49c-.3 0-.59-.11-.82-.34l-6.12-6.16-3.83 3.81c-.45.45-1.19.45-1.64 0s-.45-1.19 0-1.64l4.65-4.63c.45-.45 1.19-.45 1.64 0l6.94 6.98c.45.45.45 1.19 0 1.64-.23.23-.52.34-.82.34Z",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77 11.46v28.87c0 1.53-1.54 2.76-3.42 2.76H3.42C1.53 43.09 0 41.85 0 40.33V11.46C0 9.93 1.54 8.7 3.42 8.7h48.92c1.89 0 3.42 1.24 3.42 2.76h.01ZM3 39.68c0 .19.19.41.42.41h48.92c.23 0 .42-.22.42-.41V12.22c0-.28-.19-.53-.42-.53H3.42c-.23 0-.42.35-.42.53v27.46Z",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.11 3.38 3.42 11.56c-.65-.01-2.57-.25-2.57-1.13 0-.81 1.13-1.6 2.57-1.74L47.21.05c.13-.04.27-.06.41-.05.32 0 .63.11.88.3.37.28.57.72.56 1.18l-.14 8.57h-2.91l.1-6.68M19.68 38.21l16 .05a1.33 1.33 0 1 0 0-2.66l-16-.05a1.33 1.33 0 1 0 0 2.66Z",
    style: {
      fill: "#1d1d1b",
      strokeWidth: 0
    }
  }));
};
export default SvgIconFoldedCardLandscape;